<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="search.number"
          @keyup.enter="getOld37Logs(1)" />

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="註記"
          v-model="search.remark"
          @keyup.enter="getOld37Logs(1)" />
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getOld37Logs(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getOld37Logs"
    >
      <template #cell(created_at)="row">
        {{ convertRocDate(row.item.created_at) }}
      </template>
    </tables-page>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import oldSystemApi from "@/models/API/oldSystemApi";
import { convertRocDate } from "@/models/HELPERS/common.js";

export default {
  name: 'oldSystemAmountLog',
  components: {
    BreadCrumb,
    TablesPage
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '舊系統-操作日誌', url: '', isActive: true },
          { name: '互助金LOG', url: '', isActive: false }
        ]
      },
      search: {
        number: '',
        remark: ''
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "count",
            label: "單號",
          },
          {
            key: "member_name",
            label: "姓名",
          },
          {
            key: "number",
            label: "契約編號",
          },
          {
            key: "period",
            label: "期別",
          },
          {
            key: "type",
            label: "類別",
          },
          {
            key: "amount",
            label: "互助金",
          },
          {
            key: "remark",
            label: "註記",
          },
          {
            key: "created_at",
            label: "異動時間",
          },
          {
            key: "create_name",
            label: "建檔帳號"
          },
        ],
        page: {},
      }
    }
  },
  mounted() {
    this.oldSystemApi = new oldSystemApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.oldSystemApi.page);
      this.getOld37Logs();
    },
    convertRocDate,
    // 查詢舊系統-互助金LOG
    getOld37Logs(pageIndex = null) {
      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.oldSystemApi.getOld37Logs((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        number: '',
        remark: ''
      }

      this.getOld37Logs(1);
    }
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/oldSystemAmountLog.vue